"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.storeStream = void 0;
const rdf_stores_1 = require("rdf-stores");
/**
 * Import all quads in the given stream into a new RDF store.
 *
 * The whole stream will be consumed for this,
 * and the promise will resolve once the stream's end event is emitted.
 *
 * @param {Stream<Q extends BaseQuad>} stream An RDF stream containing the quads to import into the store.
 * @return {Promise<Store<Q extends BaseQuad>>} A promise resolving to an RDF store.
 */
function storeStream(stream) {
    const store = rdf_stores_1.RdfStore.createDefault();
    return new Promise((resolve, reject) => store.import(stream)
        .on('error', reject)
        .once('end', () => resolve(store)));
}
exports.storeStream = storeStream;
//# sourceMappingURL=index.js.map